import bannerImg from '../images/tashqiReklama/banner.png';
import orakalImg from '../images/tashqiReklama/orakal.png';
import paukImg from '../images/tashqiReklama/pauk.png';
import bortmaHarfImg from '../images/tashqiReklama/bortmaHarf.png';
import holstImg from '../images/tashqiReklama/holst.png';
import korbImg from '../images/tashqiReklama/korb.png';
import rollUpImg from '../images/tashqiReklama/rollUp.png';
import shtenderImg from '../images/tashqiReklama/shtender.png';
import stellaImg from '../images/tashqiReklama/stella.png';
import stendImg from '../images/tashqiReklama/stend.png';

const tashqiReklama = [
  {
    title: 'Banner',
    subtitle: '',
    text: 'Bannerlar tashqi reklama sohasida eng ommabop tur bo‘lib, ular tasvir obyektining yorqinligi, chop etilish shaklining keng formatda ekanligi bilan bir qator afzalliklarga  ega. Bu afzalliklar ularning ko‘zga tashlanish masofasining uzayishi va kishilar e’tiborini o‘ziga jalb etishi bilan ham xarakterlidir.',
    image: bannerImg,
    url: '/product/banner',
  },
  {
    title: 'Orakal',
    subtitle: '',
    text: 'Reklamaning bu turi fotsurat va tasvirlarni o‘zida aniq va ravshan aks ettirishi bilan hamda o‘zi yelimlanuvchi xususiyatga ega ekanligi bilan xarakterlidir. Avtomobillar, oynadan  ishlangan maxsus devorlar va shaffof to‘siqlarni bezatish hamda ularni kichik turdagi zararlanishlardan himoya qilish uchun ham samarali vositadir.Lorem ipsum dolor sit amet, consectetur adipiscing elit. In faucibus feugiat pharetra massa risus tortor leo. Non viverra tempus metus risus egestas egestas. Elementum eros, sit sapien ullamcorper ullamcorper et eget at. A netus ultrices lectus vitae.',
    image: orakalImg,
    url: '/product/orakal',
  },
  {
    title: 'Shtender',
    subtitle: '',
    text: 'Shtenderlar serqatnov joylar, ko‘p sonli do‘kon, korxona, tashkilot, klinika yoki maishiy xizmat ko‘rsatish shahobchalaridan aynan siz turgan o‘rinni alohida ta’kidlab, ajratib ko‘rsatuvchi va mahsulot hamda xizmatlar haqida ma’lumot tashuvchi samarali reklama vositalaridir.',
    image: shtenderImg,
    url: '/product/shtender',
  },
  {
    title: 'Bortma',
    subtitle: 'Harflar',
    fullName: 'Bortma Harflar',
    text: 'Tashqi reklamaning keng tarqalgan turlaridan biri bu – BO‘RTMA HARFLARDIR. Ofis, korxona,  tashkilot yoki savdo do‘konlari peshlavhalarini bo‘rtma harflar orqali aks ettirish keng  jamoatchilik va hamkorlar e’tiborini jalb qilishda samarali reklama vositasidir.',
    image: bortmaHarfImg,
    url: '/product/bortma',
  },
  {
    title: 'Korob',
    subtitle: '',
    text: "Yorug'lik qutilari reklama uchun faol ishlatiladi , ayniqsa, agar siz original yorug'lik reklamalarini boshqa reklama vositalari bilan taqqoslasangiz-yorug'lik qutilari aslida eng samarali tur hisoblanadi. Bunday reklama vositalari brendning ta'rifini  sezilarli darajada oshirishi va korxona yoki qo'mitaning iste’molchilar ko'z o'ngida yanada qiziqish uyg‘otishi mumkin.",
    image: korbImg,
    url: '/product/korob',
  },
  {
    title: 'Holst',
    subtitle: '',
    text: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. In faucibus feugiat pharetra massa risus tortor leo. Non viverra tempus metus risus egestas egestas. Elementum eros, sit sapien ullamcorper ullamcorper et eget at. A netus ultrices lectus vitae.',
    image: holstImg,
    url: '/product/holst',
  },
  {
    title: 'Pauk',
    subtitle: '',
    text: 'Reklama sohasida mobil ko‘rgazma stendlari yoki Pauklarning o‘ziga xosligi shundaki, ular uchun muayyan bir joyning tanlanishi ahamiyatsizdir. Pauklar turli xildagi loyihalar ko‘rgazmalari, marafonlar va taqdimotlar uchun o‘ziga xos qulaylikka ega bo‘lib, o‘tkazilayotgan tadbirlarning qaysi joyda va necha marotaba o‘tkazilishidan qat’I nazar ulardan foydalanish mumkin. Bu esa tashqi reklamada tejamkorlik va mahsulot yoki xizmatlar tez ommalashiahining o‘ziga xos ko‘rinishidir.',
    image: paukImg,
    url: '/product/pauk',
  },
  {
    title: 'Roll up',
    subtitle: '',
    text: 'Roll up (rollap, roll up) – tovar, mahsulot yoki xizmatlar haqidagi axborotlarni avtomatik  mexanizmi bilan harakatlanuvchi mobil stend. Prezentatsiyalar, ko‘rgazmalar, konferensiyalar va xalqaro savdo yarmarkalarida odamlar e’tiborini jalb qilish uchun eng qulay reklama vositasidir. Bundan tashqari, rollap ofislar va kompaniyalar savdo zallarida ma’lumotlar tashuvchi qulay reklama vositalaridir.',
    image: rollUpImg,
    url: '/product/rollup',
  },
  {
    title: 'Stend',
    subtitle: '',
    text: 'Ko‘rgazma stendlari marketingda tashqi reklama vositalarining eng asosiy va kuchli ta’sirga ega bo‘lgan turi hisoblanadi. Ushbu reklama vositalari orqali siz o‘z mahsulot yoki xizmatlaringiz haqida potensial mijozlar yoki boshqa iste’molchilar e’tiboriga  batafsil va aniq ma’lumot bera olasiz.',
    image: stendImg,
    url: '/product/stend',
  },
  {
    title: 'Stella',
    subtitle: '',
    text: 'Reklama stellalari brend, mahsulot yoki kompaniyani keng ommaga targ‘ib qilishning zamonaviy usulidir. Stellalar tuzilishi – baland, yorqin va ko‘zga tashlanuvchan ekanligi bilan boshqa  turdagi reklama vositalaridan ajralib turadi. Bu esa ko‘pchilik e’tiborini  o‘ziga jalb qiladi. Aynan shu xarakter stellaning o‘ziga xos reklama vositasi ekanligini ta’minlaydi.',
    image: stellaImg,
    url: '/product/stella',
  },
];

export default tashqiReklama;
